import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";

interface SecureCheckModalDialogModalData {
  title: string | (() => string);
  description?: string | (() => string);
  buttonTextAccept: string | (() => string);
  buttonTextDeny?: string | (() => string);
  icon?: string | (() => string);
}

@Component({
  selector: "ya-secureCheckDialog",
  templateUrl: "./secureCheckDialog.component.html",
  styleUrls: ["./secureCheckDialog.component.scss"]
})

export class SecureCheckDialogComponent implements OnInit {
  private _localeChangeSubscription: Subscription;

  constructor(public bottomSheetRef: MatBottomSheetRef<SecureCheckDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: SecureCheckModalDialogModalData
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SecureCheckDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    this._localeChangeSubscription = this._internationalisationService.localeChanged.subscribe(() => {
      this.PushChanges();
    });
  }

  public evaluateLanguageString(value: string | (() => string) | boolean): string {
    const me = this;
    if (typeof value === "string") {
      if (value.startsWith("ph")) {
        return me._coreLanguageService.value(value);
      } else {
        return value;
      }
    } else if (typeof value === "function") {
      return value();
    }
  }

  public acceptBtn() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public denyBtn() {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
  }
}
